import { Button } from "@aurumiq/ui/components/button";
import { useState } from "react";
import { PageHeader } from "@/app/page-header";
import { usePermission } from "@/auth/use-permission";
import { QueryState } from "@/components/query-state";
import { MediaGrid } from "@/features/cms/media-grid";
import { useMedia } from "@/features/cms/queries";
import { UploadButton } from "@/features/cms/upload-button";

export function CmsMediaPage() {
  const canWrite = usePermission("cms:write");
  const [page, setPage] = useState(1);
  const media = useMedia(page);
  const total = media.data?.total ?? 0;
  const pageSize = media.data?.page_size ?? 25;
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return (
    <>
      <PageHeader
        title="Media library"
        description="Images and files referenced by pages. Give every image alt text."
        actions={canWrite ? <UploadButton /> : null}
      />
      <QueryState query={media} rows={4}>
        {(d) => <MediaGrid items={d.items} />}
      </QueryState>
      {pages > 1 ? (
        <div className="mt-3 flex items-center justify-end gap-2 text-sm">
          <span className="text-muted-foreground">
            Page {page} of {pages}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            Previous
          </Button>
          <Button
            variant="outline"
            size="sm"
            disabled={page >= pages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next
          </Button>
        </div>
      ) : null}
    </>
  );
}
